// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';
import type { ColorScheme } from '../../../types/theme';

type Props = {
  scheme: ColorScheme,
  collapsed?: boolean,
};

const SubTitle = styled<any, Theme, Props>('h5')`
  font-size: ${props => props.theme.list.subTitle.fontSize};
  margin-bottom: ${props => (props.collapsed ? '0' : '1rem')};
  font-weight: ${props => props.theme.list.subTitle.fontWeight};
  color: ${({ scheme }) => scheme.heading};
`;

export default SubTitle;
